import React from 'react';
import { connect } from 'react-redux';

import LevelDropdown from './levelDropdown.js';
import CategoryDropdown from './categoryDropdown.js';
import ProtocolDropdown from './protocolDropdown.js';
import AnnexesDropdown from './annexesDropdown.js';
import StagesDropdown from './stagesDropdown.js';
import RefreshButton from './refreshButton.js';
import InfoTooltip from '../infoTooltip/infoTooltip.js';

import Slide from '@material-ui/core/Slide';
import Divider from '@material-ui/core/Divider';
import { _ } from '../../functions/translator.js';
// import TestButton from './testButton.js';

class FiltersSet extends React.Component {

    render() {
        const filterWidth = '18%';
        return(
            <div>
                <Slide in={ !this.props.popUpMessage.show && !this.props.popUpMenu.show } direction='down'>
                    <div className={ this.props.itemsSwitch ? 'filters-card-layout filters-right card-color' : 'filters-card-layout card-color'}>
                        <div className='filters-container flex-fill'>
                            <div style={{width: filterWidth}}>
                                <p className='text filter-title'>{ _('Etapas') }</p>
                                <StagesDropdown/>
                            </div>
                            <div style={{width: filterWidth}}>
                                <p className='text filter-title'>{ _('Planos') }</p>
                                <LevelDropdown/>
                            </div>
                            <div style={{width: filterWidth}}>
                                <p className='text filter-title'>{ _('Categorías') }</p>
                                <CategoryDropdown/>
                            </div>
                            <div style={{width: filterWidth}}>
                                <p className='text filter-title'>{ _('Protocolos') }</p>
                                <ProtocolDropdown/>
                            </div>
                            <div style={{width: filterWidth}}>
                                <p className='text filter-title'>{ _('Anexos') }
                                    <InfoTooltip message={'filters message'}/>
                                </p>
                                <AnnexesDropdown/>
                            </div>
                            <div>
                                <Divider className="divider mr-4" variant="middle" orientation="vertical"/>
                            </div>
                        </div>
                        <div>
                            <p className='text filter-title'>{ _('Recargar') }</p>
                            <RefreshButton/>
                            {/* <p className='text filter-title'>{ _('test') }</p>
                            <TestButton/> */}
                        </div>
                    </div>
                </Slide>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        itemsSwitch  : state.switches.items,
        popUpMenu    : state.popUpMenu,
        popUpMessage : state.popUpMessage
    }
}

export default connect(mapStateToProps)(FiltersSet);